import { render, staticRenderFns } from "./addGiftGoods.vue?vue&type=template&id=10b5d6fc&scoped=true"
import script from "./addGiftGoods.vue?vue&type=script&lang=js"
export * from "./addGiftGoods.vue?vue&type=script&lang=js"
import style0 from "./addGiftGoods.vue?vue&type=style&index=0&id=10b5d6fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5d6fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b5d6fc')) {
      api.createRecord('10b5d6fc', component.options)
    } else {
      api.reload('10b5d6fc', component.options)
    }
    module.hot.accept("./addGiftGoods.vue?vue&type=template&id=10b5d6fc&scoped=true", function () {
      api.rerender('10b5d6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/addGiftGoods/addGiftGoods.vue"
export default component.exports